import { render, staticRenderFns } from "./offerStatusLog.vue?vue&type=template&id=52584357&scoped=true"
import script from "./offerStatusLog.vue?vue&type=script&lang=js"
export * from "./offerStatusLog.vue?vue&type=script&lang=js"
import style0 from "./offerStatusLog.vue?vue&type=style&index=0&id=52584357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52584357",
  null
  
)

export default component.exports